import React from "react";
import Typewriter from "typewriter-effect";
import "../styles.css";
import Lottie from "react-lottie";
import * as animationData from '../utils/lotties/person2.json';
import { useTranslation } from "react-i18next";

const HomeSection = () => {
  const { t } = useTranslation(); 
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid meet",
    },
  };

  return (
    <section id="home" className="home-section">
      <div className="home-info">
        <h1 style={{ marginBottom: "10px" }}>
          {t('homeSection.welcome')} {/* Utiliza la traducción */}
        </h1>
        <h1 className="home-title">
          {t('homeSection.name')}
        </h1>
        <p className="home-profession">
          <Typewriter
              options={{
                strings: t('homeSection.profession', { returnObjects: true }), 
                autoStart: true,
                loop: true,
                deleteSpeed: 50,
                delay: 75,
                pauseFor: 1500,
              }}
          />
        </p>
        <p className="home-description">
          {t('homeSection.description')}
        </p>
      </div>
      <div className="home-lottie">
        <Lottie
          options={defaultOptions}
          height="100%"
          width="100%"
          isClickToPauseDisabled={true}
        />
      </div>
    </section>
  );
};

export default HomeSection;
